export const DEFAULT_VEHICLE_CLASS_IDENTIFIER = 'trailer_5_axle';
